module.exports = __webpack_public_path__ + "assets/img/c8cec5b51464b18cf16c6d88ca0234c8.png";